import React, { createContext } from 'react'

export const WizardDataContext = createContext(null) 